var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#324C80"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 24V20C20 18.6739 20.5268 17.4021 21.4645 16.4645C22.4021 15.5268 23.6739 15 25 15C26.3261 15 27.5979 15.5268 28.5355 16.4645C29.4732 17.4021 30 18.6739 30 20V24M18 24H32C33.1046 24 34 24.8954 34 26V33C34 34.1046 33.1046 35 32 35H18C16.8954 35 16 34.1046 16 33V26C16 24.8954 16.8954 24 18 24Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLockIcon);
export default __webpack_public_path__ + "static/media/card-lock-icon.104339a62d0abf8dd431446051af25af.svg";
export { ForwardRef as ReactComponent };